/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content"
  
}) {
let editorDisabledValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'disabled',
})
let contentValueData = fromData.useDataValue({ viewPath,
context: 'content',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z1Yf8zk': editorDisabledValueData ? 0.5 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 data="content"
 value={contentValueData}
 onChange={onChange}
/>
</div>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
{children}
</React.Fragment>)
}